// Custom script - applies live chat status classes from theme-configured hours.

(function() {
    var scheduleElement = document.getElementById('customer-hub-live-chat-schedule');

    if (!scheduleElement) {
        return;
    }

    var scheduleConfig;

    try {
        scheduleConfig = JSON.parse(scheduleElement.textContent);
    } catch (error) {
        return;
    }

    var dayKey = scheduleConfig.currentDay;
    var schedule = scheduleConfig.schedule && scheduleConfig.schedule[dayKey];
    var currentTime = scheduleConfig.currentTime;
    var isOnline = false;

    function parseTime(value) {
        if (typeof value !== 'string') {
            return null;
        }

        var trimmedValue = value.trim();
        var matchedTime = trimmedValue.match(/^(\d{1,2}):(\d{2})$/);

        if (!matchedTime) {
            return null;
        }

        var hours = Number(matchedTime[1]);
        var minutes = Number(matchedTime[2]);

        if (hours > 23 || minutes > 59) {
            return null;
        }

        return hours * 60 + minutes;
    }

    if (schedule) {
        var startMinutes = parseTime(schedule.start);
        var endMinutes = parseTime(schedule.end);
        var currentMinutes = parseTime(currentTime);

        if (startMinutes !== null && endMinutes !== null && currentMinutes !== null) {
            if (startMinutes < endMinutes) {
                isOnline = currentMinutes >= startMinutes && currentMinutes < endMinutes;
            } else if (startMinutes > endMinutes) {
                isOnline = currentMinutes >= startMinutes || currentMinutes < endMinutes;
            }
        }
    }

    var chatStatusElements = document.getElementsByClassName('chat-status');

    for (var i = 0; i < chatStatusElements.length; i++) {
        var chatStatusElement = chatStatusElements[i];
        chatStatusElement.classList.remove('online', 'offline');
        chatStatusElement.classList.add(isOnline ? 'online' : 'offline');
    }
})();